/* eslint-disable no-console */

import { register } from 'register-service-worker';

register(`${process.env.BASE_URL}service-worker.js`, {
  registered(registration) {
    registration.update();
  },
  updated() {
    if (window.location) {
      window.location.reload(true);
    }
  },
  error(error: any) {
    console.warn('Error during service worker registration:', error);
  }
});
